const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || `http://${window.location.hostname}:8080`,
};

export default config;
